import { useFormControlStateReturnType } from '../../core/hooks/useFormControlState.js';
import { useId } from '../../core/hooks/useId.js';


type UseHintProps = {
  hasError: boolean;
  id?: string;
  hint?: useFormControlStateReturnType[1];
  ariaDescribedby?: string;
};

type UseHintReturnProps = {
  hintProps: { id: string; 'aria-live': 'polite' };
  inputProps: { 'aria-describedby'?: string; 'aria-invalid': boolean };
};

/**
 * @deprecated - will be replaced with the changes to the new validation concept (FormErrorMessages).
 * @internal
 */
export function useInputHint({
  id,
  hint,
  hasError,
  ariaDescribedby: ariaDescribedbyProp,
}: UseHintProps): UseHintReturnProps {
  const _hintId = useId();
  const hintId = id ?? _hintId;
  const ariaDescribedby = [
    ariaDescribedbyProp,
    hint ? hintId : undefined,
  ].filter((value) => !!value);

  return {
    hintProps: { id: hintId, 'aria-live': 'polite' },
    inputProps: {
      'aria-describedby':
        ariaDescribedby.length > 0 ? ariaDescribedby.join(' ') : undefined,
      'aria-invalid': hasError,
    },
  };
}
